const getRuntimeConfig = () => {
    if (typeof window === 'undefined') {
        return {};
    }

    if (!window.__APP_CONFIG__ || typeof window.__APP_CONFIG__ !== 'object') {
        return {};
    }

    return window.__APP_CONFIG__;
};

// Keep explicit property access so CRA can inline compile-time values for Static Web Apps builds.
const buildTimeConfig = {
    REACT_APP_AUTH_BYPASS: process.env.REACT_APP_AUTH_BYPASS,
    REACT_APP_AZURE_B2C_API_CLIENT_ID: process.env.REACT_APP_AZURE_B2C_API_CLIENT_ID,
    REACT_APP_AZURE_B2C_AUTHORITY_DOMAIN: process.env.REACT_APP_AZURE_B2C_AUTHORITY_DOMAIN,
    REACT_APP_AZURE_B2C_DOMAIN: process.env.REACT_APP_AZURE_B2C_DOMAIN,
    REACT_APP_AZURE_B2C_USER_FLOW_EDIT_PROFILE: process.env.REACT_APP_AZURE_B2C_USER_FLOW_EDIT_PROFILE,
    REACT_APP_AZURE_B2C_USER_FLOW_FORGOT_PASSWORD: process.env.REACT_APP_AZURE_B2C_USER_FLOW_FORGOT_PASSWORD,
    REACT_APP_AZURE_B2C_USER_FLOW_SIGNIN: process.env.REACT_APP_AZURE_B2C_USER_FLOW_SIGNIN,
    REACT_APP_AZURE_CLIENT_ID: process.env.REACT_APP_AZURE_CLIENT_ID,
    REACT_APP_AZURE_STAR_EXPLORER_HOME_PAGE_ID: process.env.REACT_APP_AZURE_STAR_EXPLORER_HOME_PAGE_ID,
    REACT_APP_PHARO_BACKEND_API_URL: process.env.REACT_APP_PHARO_BACKEND_API_URL,
    REACT_APP_PHARO_BACKEND_WEBSOCKET_API_URL: process.env.REACT_APP_PHARO_BACKEND_WEBSOCKET_API_URL
};

export const env = (key, defaultValue = undefined) => {
    const runtimeConfig = getRuntimeConfig();
    if (Object.prototype.hasOwnProperty.call(runtimeConfig, key)) {
        return runtimeConfig[key];
    }

    if (Object.prototype.hasOwnProperty.call(buildTimeConfig, key) && buildTimeConfig[key] !== undefined) {
        return buildTimeConfig[key];
    }

    if (typeof process !== 'undefined' && process.env && Object.prototype.hasOwnProperty.call(process.env, key)) {
        return process.env[key];
    }

    return defaultValue;
};
